export default __webpack_public_path__ + "static/media/poudre2.e4ff5623.jpg";